import React, { useEffect, useMemo } from 'react';
import {
	Laboratory,
	useLaboratoryWorkplacesQuery,
} from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';
import SelectionList from '../../../Base/Components/SelectionList/SelectionList';
import { useAppContext } from '../../../../Services/AppContext';
import Text from '../../../../Components/Base/Text/Text';

interface Props {
	onClick: (laboratory: Laboratory) => void;
}

const LaboratoryList: React.FC<Props> = ({ onClick }) => {
	const { workplaceId } = useAppContext();
	const { data, isLoading, refetch } = useLaboratoryWorkplacesQuery({
		where: { workplaceId },
		pagination: { take: 999 },
	});

	useEffect(() => {
		refetch();
	}, []);

	const finalData: Laboratory[] = useMemo(() => {
		const tempData: Laboratory[] = [];
		data?.laboratoryWorkplaces?.data?.forEach(item => {
			if (item?.laboratory) {
				tempData.push(item.laboratory);
			}
		});
		return tempData;
	}, [data]);

	if (isLoading) {
		return <Loading />;
	}

	if (finalData.length < 1) {
		return <Text tx='component.laboratoryList.noLaboratoriesEnabled' />;
	}

	return (
		<SelectionList<Laboratory>
			data={finalData}
			onItemClick={onClick}
			buttonLabel='component.laboratoryList.selectLaboratory'
		/>
	);
};

export default LaboratoryList;
